import { Box, Flex, Text } from "@chakra-ui/react";

const menuList = [
  {
    label: "QR Scan",
    value: 0,
  },
  {
    label: "Balance",
    value: 1,
  },
  {
    label: "Activity",
    value: 2,
  },
];

const TopTab = ({
  activeIndex,
  onActiveChange,
}: {
  activeIndex: number;
  onActiveChange: (index: number) => void;
}) => {
  return (
    <Flex
      sx={{
        color: "#FFF",
        fontSize: "24px",
        fontWeight: 700,
        width: "100%",
        height: "20px",
        gap: "32px",
      }}
      align={"center"}
      justify={"center"}
    >
      {menuList.map((item, index) => {
        const isActive = activeIndex === item.value;
        return (
          <Text
            onClick={() => onActiveChange(item.value)}
            key={index}
            sx={{
              fontSize: isActive ? "20px" : "16px",
              fontWeight: isActive ? 700 : 500,
              cursor: "pointer",
              transition: "all 0.3s ease",
              color: isActive ? "#FFF" : "#FFD096",
            }}
          >
            {item.label}
          </Text>
        );
      })}
    </Flex>
  );
};

export default TopTab;
